import {isNotNil} from 'ramda';

import i18n from '@dms/i18n';

import type {BulkOperationPresentation} from 'features/eag-grid';

const VEHICLE_RESOURCE_ID = 'VEHICLE';

/** DMS resource wording and record-label conventions, shared by grids and notifications. */
export const bulkOperationPresentation: BulkOperationPresentation = {
  getRecordLabel: (resourceId, item) => {
    if (resourceId !== VEHICLE_RESOURCE_ID) {
      return undefined;
    }
    const label = item.recordLabel ?? '';
    const vehicleLabel = label.match(/^(.+) · (V\d+)$/u);
    const description = vehicleLabel?.[1];
    const code = vehicleLabel?.[2];
    return isNotNil(description) && isNotNil(code) ? {linkLabel: code, description} : undefined;
  },
  getCountLabel: (resourceId, count, formattedCount) => {
    if (resourceId !== VEHICLE_RESOURCE_ID) {
      return undefined;
    }
    return count === 1
      ? `${formattedCount} ${i18n.t('general.labels.vehicle').toLocaleLowerCase(i18n.resolvedLanguage)}`
      : i18n.t('page.salesLeague.podium.vehiclesCount', {count, replace: {count: formattedCount}});
  },
  getApplyToAllLabel: (resourceId) =>
    resourceId === VEHICLE_RESOURCE_ID
      ? i18n.t('entity.salesCampaign.labels.applyToAllVehicles')
      : undefined,
};
